// extracted by mini-css-extract-plugin
export var container = "_5t-0";
export var fallback = "_5t-5";
export var fallbackIcon = "_5t-6";
export var hidden = "_5t-2";
export var image = "_5t-3";
export var loaded = "_5t-4";
export var placeholder = "_5t-1";